<template>
  <section>
    <h2 class="heading-counter my-6">
      <span class="counter">7</span>Upload Attcachments (PDF)
    </h2>
    <v-row>
      <v-col cols="12" lg="5">
        <span>Attachment Letter</span>
        <!-- @FileUpdated="FileUpdated" -->
        <uploadFilePdf
          :maxSize="pdfSize"
          :fileUrl="form.attachment_letter && form.attachment_letter.path"
          :fileId="form.attachment_letter && form.attachment_letter.id"
          :resetToggle="resetToggle"
          class="file-upload__image my-3"
          @file_selected="UploadFile"
        />
        <a
          :href="form.attachment_name"
          target="_blank"
          v-if="isEdit === true && changeEditBoolean"
          class="mt-3"
        >
          Show File
          <!-- {{ form.attachment_name }} -->
        </a>
      </v-col>
      <v-col cols="12" lg="5">
        <span>Extra</span>
        <!-- @FileUpdated="FileUpdated" -->
        <uploadFilePdf
          :maxSize="pdfSize"
          :fileUrl="form.extra_pdf && form.extra_pdf.path"
          :fileId="form.extra_pdf && form.extra_pdf.id"
          :resetToggle="extraResetToggle"
          class="file-upload__image my-3"
          @file_selected="UploadExtraFile"
        />
        <a
          :href="form.extra_attachment"
          target="_blank"
          v-if="isEdit === true && changeExtraBoolean"
          class="mt-3"
        >
          Show File
          <!-- {{ form.extra_attachment }} -->
        </a>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pdfSize: 5,
      resetToggle: false,
      extraResetToggle: false,
      changeEditBoolean: true,
      changeExtraBoolean: true
    };
  },
  components: {
    uploadFilePdf: () => import("@/components/uploadFilePdf")
  },
  methods: {
    UploadFile(file) {
      this.form.acceptance_letter = file.file;
      this.changeEditBoolean = false;
    },
    UploadExtraFile(file) {
      this.form.extra_pdf = file.file;
      this.changeExtraBoolean = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
